function copyAttributes(source, target) {
  return Array.from(source.attributes).forEach(attribute => {
    target.setAttribute(
      attribute.nodeName === 'id' ? 'data-id' : attribute.nodeName,
      attribute.nodeValue,
    );
  });
}

class SideGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.thumnails = this.querySelectorAll('.side-gallery__thumbnail');
    this.preview = this.querySelector('.side-gallery__preview');
    this.thumnails.forEach((thumbnail) => {
      thumbnail.addEventListener('mouseenter', this.handleThumbnailHover.bind(this));
    });
  }

  handleThumbnailHover(event) {
    const closestThumbnail = event.target.closest('.side-gallery__thumbnail');
    const selectedThumbnnail = document.querySelector('.side-gallery__thumbnail--selected');

    if (selectedThumbnnail) {
      selectedThumbnnail.classList.remove('side-gallery__thumbnail--selected');
    }

    if (closestThumbnail) {
      closestThumbnail.classList.add('side-gallery__thumbnail--selected');
      const thumbnailChild = closestThumbnail.querySelector('[data-side-gallery-thumbnail]').cloneNode(true);
      if (thumbnailChild) {
        this.preview.replaceChildren(thumbnailChild);
      }
    }
  }
}
customElements.define('side-gallery', SideGallery);